export default "__VITE_ASSET__bdf13997__"